import "firebase/compat/firestore"
import "firebase/compat/auth"
import "firebase/compat/storage"
import firebase from "src/Firebase"

const db = firebase.firestore()

export const getUsuarios = (idConjunto, observer) =>
  db
    .collection("usuarios")
    .where("ConjuntoUidResidencia", "==", idConjunto)
    .where("Roles.residente", "==", true)
    .onSnapshot(observer)

export const updateUsuario = (idUser, data) =>
  db.collection("usuarios").doc(idUser).update({
    Familia: data,
  })
